import { AdminAccessApiState } from "../../Models/AdminAccessApiState";
import {
  FETCH_ADMIN_ACCESS_REQUEST,
  FETCH_ADMIN_ACCESS_SUCCESS,
  FETCH_ADMIN_ACCESS_FAILURE,
} from "./AdminAccessTypes";

const initialState: AdminAccessApiState = {
  loading: false,
  checked: false,
  hasAccess: false,
  error: "",
};

const AdminAccessReducer = (
  state = initialState,
  action: any,
): AdminAccessApiState => {
  switch (action.type) {
    case FETCH_ADMIN_ACCESS_REQUEST:
      return { ...state, loading: true };
    case FETCH_ADMIN_ACCESS_SUCCESS:
      return { ...state, loading: false, checked: true, hasAccess: action.payload, error: "" };
    case FETCH_ADMIN_ACCESS_FAILURE:
      return { ...state, loading: false, checked: true, hasAccess: false, error: action.payload };
    default:
      return state;
  }
};

export default AdminAccessReducer;
